import { component } from "picoapp";

export default component(async (node) => {
  const [
    { default: KeenSlider },
    { useFade, useAutoPlay, useNav, useAriaHidden },
  ] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const autoPlayDuration = 2000;
  const fadeDuration = "0.3s";
  const fadeTimingFunction = "linear";
  const srStopLabel = "Stop instagram carousel rotation";
  const srPlayLabel = "Resume instagram carousel rotation";

  const sliderRight = KeenSlider(
    node.querySelector("[data-keen-slider-right]"),
    {
      loop: true,
      drag: false,
      useFade: {
        duration: fadeDuration,
        timingFunction: fadeTimingFunction,
      },
      useAutoPlay: {
        duration: autoPlayDuration,
        buttonClass: "play-control",
        srButtonClass: "sr-only play-control",
        srStopButtonLabel: srStopLabel,
        srPlayButtonLabel: srPlayLabel,
      },
      created: (slider) => {
        slider.container.classList.remove("hide-init");
      },
    },
    [useFade, useAutoPlay, useAriaHidden]
  );

  const sliderLeft = KeenSlider(
    node.querySelector("[data-keen-slider-left]"),
    {
      loop: true,
      drag: false,
      useFade: {
        duration: fadeDuration,
        timingFunction: fadeTimingFunction,
      },
      useAutoPlay: {
        duration: autoPlayDuration,
        buttonClass: "play-control",
        srButtonClass: "sr-only play-control",
        srStopButtonLabel: srStopLabel,
        srPlayButtonLabel: srPlayLabel,
        srPresentation: true,
      },
      created: (slider) => {
        slider.container.classList.remove("hide-init");
        slider.options.useAutoPlay.isPlaying = true;
      },
    },
    [useFade, useAutoPlay, useNav(sliderRight), useAriaHidden]
  );

  function refresh(sliderLeft, sliderRight) {
    if (
      sliderLeft.options.useAutoPlay.isPlaying ||
      sliderRight.options.useAutoPlay.isPlaying
    ) {
      if (window.innerWidth > 860) {
        sliderLeft.emit("play");
        sliderRight.emit("stop");
      } else {
        sliderLeft.emit("stop");
        sliderRight.emit("play");
      }
    } else {
      sliderLeft.emit("stop");
      sliderRight.emit("stop");
    }
  }

  window.addEventListener("resize", () => refresh(sliderLeft, sliderRight));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        refresh(sliderLeft, sliderRight);
      } else {
        sliderLeft.emit("stopSilently");
        sliderRight.emit("stopSilently");
      }
    });
  });

  observer.observe(node);
});
